module.exports = __webpack_public_path__ + "img/window.ddba3f2.svg";